import AiSceneCards from './AiSceneCards.vue'
// form 可用于未来的产品配置、批量参数填写等场景，当前暂未接入；仅保留设计说明，不声明能力或提供提交入口。
// 新增组件：独立 Vue 文件 + 此注册项 + component-support.js 版本声明 + contract 校验 + 样例/测试。
import AiText from './AiText.vue'
import AiDeviceCards from './AiDeviceCards.vue'
import AiActionList from './AiActionList.vue'
import AiInfoList from './AiInfoList.vue'
import AiDetailViews from './AiDetailViews.vue'
import AiTask from './AiTask.vue'
export default { text: AiText, device_cards: AiDeviceCards, scene_cards: AiSceneCards, action_list: AiActionList, info_list: AiInfoList, task: AiTask, detail_views: AiDetailViews }
